import { decamelize } from 'helpers/camelize';
import {
  fetchWrapper,
  handleResponse,
  hcUrlV3,
  buildOpts,
  objectToQueryString,
} from 'services/RequestService/helpers';

export const getMealPrices = async ({ params }) => {
  const response = await fetchWrapper(
    hcUrlV3(`/weekly_basket/meal_prices?${objectToQueryString(decamelize(params))}`),
    buildOpts()
  );

  return handleResponse(response);
};

export const getMealPrice = async ({ params }) => {
  const { menuId, menuSlug, mealId } = params;
  const menuIdParam = menuId || menuSlug;

  const response = await fetchWrapper(
    hcUrlV3(
      `/weekly_basket/meal_prices/${mealId}?menu_id=${menuIdParam}&${objectToQueryString(decamelize(params))}`
    ),
    buildOpts()
  );

  return handleResponse(response);
};
